import { render, staticRenderFns } from "./NotesTab.vue?vue&type=template&id=49f22fac"
import script from "./NotesTab.vue?vue&type=script&lang=js"
export * from "./NotesTab.vue?vue&type=script&lang=js"
import style0 from "./NotesTab.vue?vue&type=style&index=0&id=49f22fac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports